<script>
import { mapActions, mapGetters } from 'vuex';

import TaxonListItem from './TaxonListItem.vue';
import SimplePlaceholder from '../kit/SimplePlaceholder.vue';

export default {
  name: 'TaxonList',
  components: { TaxonListItem, SimplePlaceholder },
  computed: {
    ...mapGetters({
      taxons: 'search/taxons',
    }),
    isLoading() {
      return !this.taxons;
    },
  },
  methods: {
    ...mapActions({
      setTaxon: 'search/setTaxon',
    }),
  },
};
</script>

<template>
  <div class="hidden md:block flex flex-col text-gray-800 text-sm border border-gray-300">
    <div class="flex-grow-0 w-full bg-gray-diagomics-light font-semibold text-base
  md:text-lg p-2">
      <div>
        <router-link :to="{ name: 'home' }" class="hover:text-blue-diagomics-dark">
          {{ $tc('category', 2) }}
        </router-link>
      </div>
    </div>

    <div class="text-base">
      <ul v-if="isLoading">
        <li class="px-2 py-1">
          <SimplePlaceholder v-for="index in 3" :key="index" class="my-1" />
        </li>
      </ul>
      <ul class="flex flex-col" v-else>
        <TaxonListItem :taxonomy="taxonomy" v-for="taxonomy in taxons" :key="taxonomy.id" />
      </ul>
    </div>
  </div>
</template>
